import {useDispatch, useSelector} from 'react-redux';
import {memberElectionSelector} from '../../redux/selectors/MemberElectionSelector';
import {criticalIllnessRateSelector} from '../../redux/selectors/CriticalIllnessRateSelector';

export const useCriticalIllnessCoverageRemover = () => {
    const memberElection = useSelector(memberElectionSelector);
    const criticalIllnessCoverage = useSelector(criticalIllnessRateSelector);
    const dispatch = useDispatch();

    const removeEnrolledCoverage = (benefitKey) => {
        let benefitKeysToRemove = getBenefitKeysToRemove(benefitKey);

        const dependents = memberElection.familyDemographics.dependents
            .map(dependent => ({
                    ...dependent,
                    coverages: dependent.coverages
                        .filter(dependentCoverageBenefitKey => !benefitKeysToRemove.includes(dependentCoverageBenefitKey))
                })
            );

        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: {
                benefitOptions: memberElection.benefitOptions
                    .filter(benefitOption => !benefitKeysToRemove.includes(benefitOption.benefitKey)),
                enrolledCoverages: memberElection.enrolledCoverages
                    .filter(enrolledCoverage => !benefitKeysToRemove.includes(enrolledCoverage.benefitKey)),
                familyDemographics: {dependents: dependents}
            }
        });
    };

    const getBenefitKeysToRemove = (benefitKey) => {
        let benefitKeysToRemove = [benefitKey];

        if (benefitKey === criticalIllnessCoverage.benefitKey) {
            benefitKeysToRemove.push(criticalIllnessCoverage.spouseBenefitKey);
            benefitKeysToRemove.push(criticalIllnessCoverage.childBenefitKey);
        }
        return benefitKeysToRemove;
    };

    return (benefitKey) => removeEnrolledCoverage(benefitKey);
};

